import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReadMore from '../common/ui/ReadMore';
import CompactCurrencyFilter from './PricingUtils';

class ProductInfoTabs extends Component {
  constructor(props) {
    super(props);

    this.selectTab = this.selectTab.bind(this);

    this.state = {
      selectedTab: 0,
    };
  }

  selectTab(index) {
    this.setState({
      selectedTab: index,
    });
  }

  /* eslint-disable react/no-danger */
  render() {
    const { collectionItem } = this.props;

    return (
      <div className="product-info-tabs">
        <ul className="nav nav-tabbed">
          <li className={this.state.selectedTab === 0 ? 'active' : ''}>
            <a role="button" onClick={() => this.selectTab(0)}>
              Description
            </a>
          </li>
          <li className={this.state.selectedTab === 1 ? 'active' : ''}>
            <a role="button" onClick={() => this.selectTab(1)}>
              Details
            </a>
          </li>
          <li className={this.state.selectedTab === 2 ? 'active' : ''}>
            <a role="button" onClick={() => this.selectTab(2)}>
              Brand
            </a>
          </li>
          <li className={this.state.selectedTab === 3 ? 'active' : ''}>
            <a role="button" onClick={() => this.selectTab(3)}>
              Shipping<span className="hidden-xs"> &amp; Returns</span>
            </a>
          </li>
        </ul>
        <ReadMore className="tab-content">
          <div
            id="product-description-tab"
            className={`tab-pane${this.state.selectedTab === 0 ? ' active' : ''}`}
            dangerouslySetInnerHTML={{ __html: collectionItem.description }}
          />
          <div
            id="product-details-tab"
            className={`tab-pane${this.state.selectedTab === 1 ? ' active' : ''}`}
          >
            {collectionItem.detail_items.map(detailItem => (
              <div key={detailItem.label} className="value-label">
                <strong>{detailItem.label}:</strong> {detailItem.value}
              </div>
            ))}
          </div>
          <div
            id="product-brand-tab"
            className={`tab-pane${this.state.selectedTab === 2 ? ' active' : ''}`}
            dangerouslySetInnerHTML={{ __html: collectionItem.brand.description }}
          />
          <div
            id="product-shipping-tab"
            className={`tab-pane${this.state.selectedTab === 3 ? ' active' : ''}`}
          >
            {collectionItem.delivery_surcharge > 0 && (
              <div className="value-label">
                <strong>Delivery Surcharge:</strong> Due to its weight or perishable nature, this
                item has an incremental delivery surcharge of{' '}
                {CompactCurrencyFilter(collectionItem.delivery_surcharge)}.
              </div>
            )}
            <div className="value-label">
              <strong>Shipping Method:</strong> {collectionItem.ship_method}
            </div>
            <div className="value-label">
              <strong>Return Policy:</strong> {collectionItem.return_policy}{' '}
              <a target="_blank" rel="noopener noreferrer" href="/returns">
                See details ›
              </a>
            </div>
            {collectionItem.partner_retailer && (
              <div className="value-label">
                This product ships from {collectionItem.partner_retailer.name}.
              </div>
            )}
          </div>
        </ReadMore>
      </div>
    );
  }
}

ProductInfoTabs.propTypes = {
  collectionItem: PropTypes.shape({}),
};

export default ProductInfoTabs;



// WEBPACK FOOTER //
// ./src/components/product/ProductInfoTabs.jsx